export default "__VITE_ASSET__B5b1ojfq__"